const DescriptiveSummary = function(min, max, median, mean, stdDev, count) {
    this.min = min;
    this.max = max;
    this.median = median;
    this.mean = mean;
    this.standardDev = stdDev;
    this.count = count;
}

const TagCard = function(preOp, oneMonthPostOp, sixMonthsPostOp, twelveMonthsPostOp) {
    this.preOp = preOp;
    this.oneMonthPostOp = oneMonthPostOp;
    this.sixMonthsPostOp = sixMonthsPostOp;
    this.twelveMonthsPostOp = twelveMonthsPostOp;
}

const TagRow = function(descSummary, median, months) {
    this.descriptiveSummary = descSummary;
    this.median = median;
    this.months = months;
};

const createEmptyTagCard = function() {
    let summaryPreOp = new DescriptiveSummary("-", "-", "-", "-", "-", "-");
    let summaryOneMonthPostOp = new DescriptiveSummary("-", "-", "-", "-", "-", "-");
    let summarySixMonthsPostOp = new DescriptiveSummary("-", "-", "-", "-", "-", "-");
    let summaryTwelveMonthsPostOp = new DescriptiveSummary("-", "-", "-", "-", "-", "-");
    
    let tagRowPreOp = new TagRow(summaryPreOp, "-", "-");
    let tagRowOneMonthPostOp = new TagRow(summaryOneMonthPostOp, "-", "-");
    let tagRowSixMonthsPostOp = new TagRow(summarySixMonthsPostOp, "-", "-");
    let tagRowTwelveMonthsPostOp = new TagRow(summaryTwelveMonthsPostOp, "-", "-");

    return new TagCard(tagRowPreOp, tagRowOneMonthPostOp, tagRowSixMonthsPostOp, tagRowTwelveMonthsPostOp);
}

export { createEmptyTagCard };